import { useEffect, useState } from "react";
import api from "@/lib/api";

export function useCustomFields(entity) {
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let ok = true;
    api.get(`/custom-fields?entity=${entity}`)
      .then((r) => { if (ok) setFields(r.data); })
      .catch(() => { if (ok) setFields([]); })
      .finally(() => { if (ok) setLoading(false); });
    return () => { ok = false; };
  }, [entity]);
  return { fields, loading };
}

export function CustomFieldsRenderer({ fields, values, onChange }) {
  if (!fields || fields.length === 0) return null;
  const setValue = (key, v) => onChange({ ...(values || {}), [key]: v });
  return (
    <>
      {fields.map((f) => {
        const v = values?.[f.field_key] ?? "";
        const testId = `cf-${f.field_key}`;
        if (f.field_type === "select") {
          return (
            <label key={f.id} className="block">
              <div className="overline mb-2">{f.label}{f.required && "*"}</div>
              <select
                required={f.required}
                value={v}
                onChange={(e) => setValue(f.field_key, e.target.value)}
                className="input-field"
                data-testid={testId}
              >
                <option value="">Select…</option>
                {f.options?.map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
            </label>
          );
        }
        return (
          <label key={f.id} className="block">
            <div className="overline mb-2">{f.label}{f.required && "*"}</div>
            <input
              type={f.field_type === "number" ? "number" : f.field_type === "date" ? "date" : "text"}
              required={f.required}
              value={v}
              onChange={(e) => setValue(f.field_key, e.target.value)}
              className={`input-field ${f.field_type === "number" || f.field_type === "date" ? "font-mono" : ""}`}
              data-testid={testId}
            />
          </label>
        );
      })}
    </>
  );
}

export function CustomDataCell({ fields, data }) {
  if (!fields?.length || !data) return null;
  const items = fields
    .map((f) => ({ label: f.label, value: data[f.field_key] }))
    .filter((x) => x.value !== undefined && x.value !== "");
  if (!items.length) return <span className="text-zinc-400">—</span>;
  return (
    <div className="flex flex-wrap gap-1">
      {items.map((it) => (
        <span key={it.label} className="text-[10px] font-sans px-1.5 py-0.5 bg-zinc-100 border border-zinc-200 text-zinc-700 uppercase tracking-wide">
          <span className="text-zinc-500">{it.label}:</span> {String(it.value)}
        </span>
      ))}
    </div>
  );
}
